import React, { useContext, useEffect, useRef } from 'react';
import { Button, Col, Form, Row } from "react-bootstrap";
import ButtonLoader from "../../CommonComponent/ButtonLoader/ButtonLoader";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { ChalanUpdateAndReturnContext } from "../ChalanUpdateAndReturnComponent";
import { chalanDetailUpdateAction } from "../../../Redux/Action/PurAction";

function ChalanDetailUpdateForm({ is_stock_return }) {
    // hooks
    const dispatch = useDispatch()
    const chalanDetailUpdateRef = useRef()
    // getting data from context
    const {
        singleChalanForUpdate,
        chalanGetFieldRef,
        setNewOnClickState,
        chalanGetForUdpateAndReturnOnSubmit,
    } = useContext(ChalanUpdateAndReturnContext)
    // hook form
    const { register, handleSubmit, getValues, setValue, reset, resetField, formState: { errors } } = useForm();

    // set default value lifecycle
    useEffect(() => {
        Object.keys(getValues()).map(fieldProps => {
            resetField(fieldProps)
            fieldProps == "reference" && setValue(fieldProps, singleChalanForUpdate.reference || "")
            fieldProps == "remark" && setValue(fieldProps, singleChalanForUpdate.remark || "")
        })
    }, [singleChalanForUpdate])

    // form submit
    const onSubmit = async data => {
        // making payload for update
        const payload = {
            data: { ...data, chalan_no: singleChalanForUpdate.chalan_no },
            chalanDetailUpdateRef,
            chalanGetFieldRef,
            setNewOnClickState,
            chalanGetForUdpateAndReturnOnSubmit,
        }
        // action dispatch
        dispatch(chalanDetailUpdateAction(payload))
    }
    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="d-flex ">
                    {/*reference field*/}
                    <Col md={6}>
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Reference</Form.Label>
                            <Form.Control
                                disabled={is_stock_return}
                                defaultValue={""}
                                type="text"
                                placeholder="Enter reference"
                                className={`${errors.reference ? "is-invalid" : ""}`}
                                {...register("reference", { required: false })}
                            />
                            {/*validation message*/}
                            {errors.reference && <span className="text-danger">This field is required</span>}
                        </Form.Group>
                    </Col>
                    <Col xs={12}></Col>
                    {/*vendor name field*/}
                    <Col md={6}>
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Vendor name</Form.Label>
                            <Form.Control
                                defaultValue={singleChalanForUpdate.cfg_vendor?.vendor_name || ""}
                                disabled={true}
                                type="text"
                                placeholder="vendor name"
                            />
                        </Form.Group>
                    </Col>
                    {/*vendor phone field*/}
                    <Col md={6}>
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Vendor phone</Form.Label>
                            <Form.Control
                                defaultValue={singleChalanForUpdate.cfg_vendor?.phone || ""}
                                type="text"
                                disabled={true}
                                placeholder="vendor phone"
                            />
                        </Form.Group>
                    </Col>
                    {/*vendor email field*/}
                    <Col md={6}>
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Vendor email</Form.Label>
                            <Form.Control
                                defaultValue={singleChalanForUpdate.cfg_vendor?.email || ""}
                                type="text"
                                disabled={true}
                                placeholder="vendor email"
                            />
                        </Form.Group>
                    </Col>
                    {/*vendor address field*/}
                    <Col md={6}>
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Vendor address</Form.Label>
                            <Form.Control
                                defaultValue={singleChalanForUpdate.cfg_vendor?.address || ""}
                                type="text"
                                disabled={true}
                                placeholder="vendor address"
                            />
                        </Form.Group>
                    </Col>
                    {/*remark field*/}
                    <Col xs={12}>
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Remark</Form.Label>
                            <Form.Control
                                disabled={is_stock_return}
                                type="text"
                                placeholder="any remark"
                                className={`${errors.remark ? "is-invalid" : ""}`}
                                {...register("remark", { required: false })}
                            />
                            {/*validation message*/}
                            {errors.remark && <span className="text-danger">This field is required</span>}
                        </Form.Group>
                    </Col>
                </Row>


                {!is_stock_return && <Button ref={chalanDetailUpdateRef} variant="success" className="mt-2 btn-sm" type="submit">
                    Update
                    <ButtonLoader />
                </Button>}
            </Form>
        </>
    );
}

export default ChalanDetailUpdateForm;